import { createStore } from 'vuex';
import axios from 'axios';

export default createStore({
    state: {
        config: {},
        user: null,
        sites: null,
        apis: null,
    },
    mutations: {
        setConfig(state, data) {
            state.config = data;
        },
        setUser(state, data) {
            state.user = data;
        },
        setSites(state, data) {
            state.sites = data;
        },
        setApis(state, data) {
            state.apis = data;
        },
    },
    actions: {
        loadConfig({ commit }) {
            commit('setConfig', config);
        },
        async fetchData({ commit }) {
            try {
                const response = await axios.get(getConfig().serverURL + "/server/protected.php", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                });

                if (response.data.success) {
                    commit('setUser', response.data.user);
                    commit('setSites', response.data.sites);
                    commit('setApis', response.data.apis);

                    return { success: true };
                } else {
                    return { success: false, message: 'Error data' };
                }
            } catch (error) {
                console.error("Error login:", error);
                return { success: false, message: error.message };
            }
        }
    },
    getters: {
        config: (state) => state.config,
        user: (state) => state.user,
        sites: (state) => state.sites,
        apis: (state) => state.apis,
    },
});

let config = null;

export async function loadConfig() {
    if (!config) {
        const response = await fetch('/config-front.json');
        if (!response.ok) {
            throw new Error(`Ошибка загрузки конфигурации: ${response.status}`);
        }
        config = await response.json();
    }
    return config;
}

await loadConfig();

export function getConfig() {
    return config;
}
